import { Injectable } from '@angular/core';

import { ClientTranslationKeyModel } from '../../models/language-locale.model';

@Injectable({
	providedIn: 'root'
})
export class UserEditStorageService {
	private _modifiedClientTranslationKey: ClientTranslationKeyModel = null;

	private _hasOutstandingChanges: boolean = false;

	public get modifiedClientTranslationKey() {
		return this._modifiedClientTranslationKey;
	}

	public set modifiedClientTranslationKey(userEdits: ClientTranslationKeyModel | null) {
		if (userEdits) {
			this._hasOutstandingChanges = true;
			this._modifiedClientTranslationKey = userEdits;
		} else {
			this._modifiedClientTranslationKey = null;
			this._hasOutstandingChanges = false;
		}
	}

	public get hasOutstandingChanges() {
		return this._hasOutstandingChanges;
	}

	constructor() {}
}
